'use client'
import exploreHotelsData from '@/src/constants/hotels/homeExploreHotels.json'
import { useLocale, useTranslations } from 'next-intl'
import { useMemo } from 'react'
import ExploreMoreHotels, { ExploreCity } from './exploreMoreHotels'

// Logic layer: resolves the localized city + hotel names/links for the Explore-more-Hotels
// grid (ported from me-flyin's xplrHsect static list).
const ExploreMoreHotelsWrapper: React.FC = () => {
    const t = useTranslations('homePage.headings')
    const locale = useLocale()
    const isArabic = locale === 'ar'

    const cities = useMemo<ExploreCity[]>(
        () =>
            exploreHotelsData.cities.map(city => ({
                id: city.id,
                iconKey: city.iconKey,
                name: isArabic ? city.name_ar || city.name_en : city.name_en,
                hotels: city.hotels.map(hotel => ({
                    name: isArabic ? hotel.name_ar || hotel.name_en : hotel.name_en,
                    href: isArabic ? hotel.href_ar || hotel.href_en : hotel.href_en
                }))
            })),
        [isArabic]
    )

    if (cities.length === 0) return null

    return <ExploreMoreHotels title={t('exploreMoreHotels')} cities={cities} />
}

export { ExploreMoreHotelsWrapper }
export default ExploreMoreHotelsWrapper
